import { render, staticRenderFns } from "./MailTemplateEditor.vue?vue&type=template&id=1dfda2b6"
import script from "./MailTemplateEditor.vue?vue&type=script&lang=ts"
export * from "./MailTemplateEditor.vue?vue&type=script&lang=ts"
import style0 from "./MailTemplateEditor.vue?vue&type=style&index=0&id=1dfda2b6&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dfda2b6')) {
      api.createRecord('1dfda2b6', component.options)
    } else {
      api.reload('1dfda2b6', component.options)
    }
    module.hot.accept("./MailTemplateEditor.vue?vue&type=template&id=1dfda2b6", function () {
      api.rerender('1dfda2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail/MailTemplateEditor.vue"
export default component.exports